import React from 'react'
import PropTypes from 'prop-types'

import { EMVestWrapper, Content, Heading } from './style'

import WidgetWrapper from '../WidgetWrapper'

import PoiList from './components/PoiList'
import ReadMoreButton from './components/ReadMoreButton'

const style = {
  background: '#F9F1E6',
  margin: '0',
}

const EMVestWidget = React.memo(({ links, pois }) => (
  <WidgetWrapper style={style}>
    <EMVestWrapper>
      <Content>
        <Heading>I nærheten</Heading>
        <PoiList pois={pois} />
        <ReadMoreButton link={links.main} />
      </Content>
    </EMVestWrapper>
  </WidgetWrapper>
))

EMVestWidget.propTypes = {
  links: PropTypes.shape({
    main: PropTypes.string.isRequired,
    map: PropTypes.string.isRequired,
  }),
  location: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  pois: PropTypes.arrayOf(
    PropTypes.shape({
      distanceText: PropTypes.string,
      poiId: PropTypes.string,
      poiType: PropTypes.string,
      poiTypeId: PropTypes.number,
      travelType: PropTypes.string,
    }),
  ).isRequired,
}

export default EMVestWidget
